import Schema from "../details/validation"
import { getColumnSize } from "modules/common/services/table/size-storage"
import { getFieldLabel } from "modules/common/services/form/fields"
import { fields } from "../../models/project-portfolio"
import { ColDef } from "@ag-grid-community/core"
import { RowNumberColumn } from "modules/common/services/table/helpers"

const schema = Schema()

export const columns = (tableName: string) => {
    const columnSize = getColumnSize(tableName)

    const result: ColDef[] = [
        RowNumberColumn(false, ""),
        {
            headerName: getFieldLabel(fields.name, schema, null),
            field: fields.name,
            width: columnSize(fields.name, 300),
            sortable: true,
            resizable: true,
        },
        {
            headerName: getFieldLabel(fields.director, schema, null),
            field: fields.director,
            width: columnSize(fields.director, 250),
            sortable: false,
            resizable: true,
            cellRendererFramework: (data: any) => {
                if (data.data.director !== null) {
                    return data.data.director.name
                }
                return null
            },
        },
        {
            headerName: getFieldLabel(fields.description, schema, null),
            field: fields.description,
            width: columnSize(fields.description, 700),
            sortable: false,
            resizable: true,
        },

    ]

    return result
}
